import styled from "styled-components";

export const Container = styled.main`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    svg{
        color: ${(props) => props.theme.colors.gray.gray_600};
    }
`;

export const Infor = styled.div``;

export const Title = styled.p`
    font-size: 24px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
`;

export const SubTitle = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ButtonClose = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
`;

export const Content = styled.div`
    background-color: ${(props) => props.theme.colors.white};
    width: 600px;
    padding: 30px;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    gap: 20px;
`;